var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-popover", {
    attrs: {
      placement: _vm.placement,
      trigger: _vm.trigger,
      width: _vm.width,
      "popper-class": _vm.popperClass,
      "append-to-body": _vm.appendToBody,
      disabled: _vm.disabled
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("div", [_vm.title ? _c("div", {
    staticClass: "popover-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm.content ? _c("div", {
    staticClass: "popover-content"
  }, [_vm._v(_vm._s(_vm.content))]) : _vm._e(), _vm._t("content", function () {
    return [_c("div", {
      attrs: {
        slot: "content"
      },
      slot: "content"
    })];
  }), _vm._t("default")], 2), _c("div", {
    staticStyle: {
      "text-align": "right",
      "margin-top": "8px"
    }
  }, [_c("el-button", {
    attrs: {
      size: "mini"
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.confirmText))])], 1), _c("div", {
    attrs: {
      slot: "reference"
    },
    slot: "reference"
  }, [_vm._t("reference")], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };